import ContainerAccountSettings from "../../Component/AccountSettings/AccountSetting"

const AccountSettingsPage = () => {
  return (
    <div className='page-body'>
      <ContainerAccountSettings />
    </div>
  )
}

export default AccountSettingsPage